import React from "react"
import {Route, RouteProps, Routes} from "react-router-dom";
import {FacilityListPage} from "@/pages/facilities/facility-list";
import {NewFacility} from "@/pages/facilities/new-facility";
import {EditFacility} from "@/pages/facilities/edit-facility";
import {ImportFacilities} from "@/pages/facilities/import-facilities";
import {BodyWrapper} from "@/components/body-wrapper";


export function FacilityRoutes() {
    return (
        <BodyWrapper>

                <Routes>
                    <Route
                        path="/"
                        element={
                            <FacilityListPage/>
                        }
                    />

                    <Route
                        path="/create"
                        element={
                            <NewFacility/>
                        }
                    />

                    <Route
                        path="/import"
                        element={
                            <ImportFacilities/>
                        }
                    />

                    <Route
                        path="/edit/:id"
                        element={
                            <EditFacility/>
                        }
                    />

                </Routes>
        </BodyWrapper>
    )
}